/* eslint-disable no-undef */
(function () {
    'use strict'

    angular.module('MktzapApp.Factories')
        .factory('In100ReportTransactionsService', In100ReportTransactionsService)

    In100ReportTransactionsService.$inject = ['$resource']

    function In100ReportTransactionsService($resource) {
        return $resource('', {}, {
            paged: {
                url: apiUrl + '/reports/in100-transactions-search',
                method: 'GET',
                params: {},
                isArray: false
            }
        })
    }
    // eslint-disable-next-line semi
})();
